/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Format de date utilisé par tous les `DateInput` de l'assistant (acte,
 * naissance, reconnaissance, mentions). Centralisé ici car redéclaré en dur
 * dans plusieurs fichiers (`useCreateActeNaissance`, `validationInformationsActe`,
 * `MentionForm`, `InformationsActe`).
 */
export const DATE_FORMAT = 'DD/MM/YYYY';

/** Format de date attendu par l'API (back). */
export const API_DATE_FORMAT = 'YYYY-MM-DD';
